export const getActiveIntegrationLabel = (i) => {
  if (i.o365) return 'Office 365'
  else if (i.gmail_serverside || i.gmail_webhooks) return 'GSuite'
  else if (i.exchange) return 'Exchange'
  else return 'None'
}

// serverside_type
export const INTEGRATION_TYPE = {
  O365: 3,
  GSUITE: 2,
}
